// The query parameters Sales → Sales Order Line Exceptions reads on load, so the Sales Order Board's
// "Open in Exceptions list" opens it with the board's filters (Sales Order Board D-14). Dates are
// yyyy-MM-dd; customer is the text shown in the Customer search box.
export enum SalesOrderLineExceptionsQueryParameters {
  fromDate = 'fromDate',
  toDate = 'toDate',
  customerId = 'customerId',
  customer = 'customer',
}
